import { tag, el } from '@aspectus/vue-dermis';
import { createBlockGenerator } from '@aspectus/bem';

const b = createBlockGenerator();

export const [TabsTag, block] = tag('vue-tabs', {}, b);
export const TabsLabelsTag = el('vue-tabs-labels', block, {}, 'labels');
export const TabTag = el('vue-tabs-tab', block, {}, 'tab');
